import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {LangChange} from '../../../../../../lang-change';
import {Utils} from '../../../../../../common/services/Utils';
import {EnrollCabinet} from '../../../model/enroll-cabinet';
import {TranslateService} from '@ngx-translate/core';
import {MatDialog} from '@angular/material';
import {Language} from '../../../../../../common/models/language';
import {AddPrivilegeDialogComponent} from './add-privilege-dialog/add-privilege-dialog.component';
import {FileService} from '../../../../../shared/services/file.service';
import {FileServiceModerator} from '../../../../../moderator/services/file-service-moderator.service';
import {EnrollPrivilegesItems} from '../../../model/enroll-privileges-items';

@Component({
  selector: 'app-enroll-privileges',
  templateUrl: './enroll-privileges.component.html',
  styleUrls: ['./enroll-privileges.component.scss']
})
export class EnrollPrivilegesComponent extends LangChange implements OnInit {

  maxFileSize = 5012000;

  constructor(public _translateService: TranslateService,
              private dialog: MatDialog,
              private fileService: FileService,
              private fileModeratorService: FileServiceModerator,
              private utils: Utils) {
    super(_translateService);
  }

  @Input() public data: EnrollCabinet;
  @Input() public dics: any;
  @Input() public applicationFormDisabled: boolean;
  @ViewChild('photoFileInput') fileInputVariable;

  onLangChange(language: Language): void {
  }

  ngOnInit() {
  }

  addPrivilegeInfo(editdata? : any, id? : any) {
    this.dialog.closeAll();
    const dialogRef = this.dialog.open(AddPrivilegeDialogComponent, {
      width: '50%',
      // height: '75%',
      disableClose: true,
      data: { dics: this.dics, data: (editdata ? Object.assign(new EnrollPrivilegesItems(), editdata) : new EnrollPrivilegesItems()) }
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        // console.log(result)
        if (!editdata) {
          this.data.privileges.privileges.push(result);
        } else if(editdata && id) {
          this.data.privileges.privileges[id] = result;
        }
      } else {
        // this.utils.notifyError("error_occurred", "");
      }
    });
  }

  getBenefitName(id: any) {
    if(id) {
      for (let b of this.dics['benefits']) {
        if (b['id'] == id) {
          return b['name'];
        }
      }
    }
  }
  getQuotasName(id: any) {
    if(id) {
      for (let b of this.dics['quotas']) {
        if (b['id'] == id) {
          return b['name'];
        }
      }
    }
  }

  getFile(id: any) {
    this.utils.blockStart(null);
    this.fileService.getFileInfo(id).subscribe((fileInfo) => {
      this.fileService.getFile(fileInfo.fileId).subscribe((data) => {
        this.fileService.downloadPsFile(data, fileInfo);
        this.utils.blockStop();
      });
    });
  }

  deleteItem(i) {
    this.utils.confirmDialog({message: 'delete_confirmation'}, () => {
      if (this.data.privileges.privileges[i]['privileges_files']['fileId']) {
        this.fileModeratorService.deleteFile(this.data.privileges.privileges[i]['privileges_files']['fileId']).subscribe(res => {});
      }
      this.data.privileges.privileges.splice(i, 1);
    });
  }

  // для квота

  fileInputChangeEvent(fileInput: any) {
    if (fileInput.target.files && fileInput.target.files[0]) {
      if (fileInput.target.files[0].size > this.maxFileSize) {
        this.utils.notifyError(this._translateService.instant('enroll_cabinet_page.upload_file_size_exceed'), "");
        return false;
      } else {
        const file:File = fileInput.target.files[0];
        const formData = new FormData();
        formData.append('file', file, file.name);
        this.fileModeratorService.uploadFile(formData).subscribe(res => {
          this.data.quota.file = res;
        });
      }
    }
  }

  deleteFile(fileId: any) {
    this.utils.confirmDialog({message: 'delete_confirmation'}, () => {
      this.fileModeratorService.deleteFile(fileId).subscribe(res => {
        this.data.quota.file = {fileId: null};
      });
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/enroll/components/enroll-cabinet/tabs/enroll-privileges/enroll-privileges.component.ts